import React, { useState } from 'react';
import {
  View, Text, TextInput, TouchableOpacity, StyleSheet,
  KeyboardAvoidingView, Platform, ScrollView, ActivityIndicator,
} from 'react-native';
import { useAuth } from '../context/AuthContext';

export default function RegisterScreen({ navigation }) {
  const { register } = useAuth();
  const [form, setForm] = useState({
    nome: '', email: '', senha: '', telefone: '', documento: '', tipo_usuario: 'locatario',
  });
  const [loading, setLoading] = useState(false);
  const [erro,    setErro]    = useState('');

  const update = (key, value) => setForm(f => ({ ...f, [key]: value }));

  const handleRegister = async () => {
    setErro('');
    if (!form.nome.trim() || !form.email.trim() || !form.senha.trim()) {
      return setErro('Nome, e-mail e senha são obrigatórios');
    }
    if (form.senha.length < 6) {
      return setErro('A senha deve ter pelo menos 6 caracteres');
    }
    setLoading(true);
    try {
      await register({ ...form, email: form.email.trim().toLowerCase() });
    } catch (err) {
      setErro(err.message);
    } finally {
      setLoading(false);
    }
  };

  const TipoBtn = ({ value, label }) => (
    <TouchableOpacity
      onPress={() => update('tipo_usuario', value)}
      style={[styles.tipoBtn, form.tipo_usuario === value && styles.tipoBtnActive]}
    >
      <Text style={[styles.tipoBtnText, form.tipo_usuario === value && styles.tipoBtnTextActive]}>
        {label}
      </Text>
    </TouchableOpacity>
  );

  return (
    <KeyboardAvoidingView style={{ flex: 1 }} behavior={Platform.OS === 'ios' ? 'padding' : undefined}>
      <ScrollView style={styles.container} contentContainerStyle={{ paddingBottom: 40 }} keyboardShouldPersistTaps="handled">

        <Text style={styles.title}>Criar Conta</Text>
        <Text style={styles.subtitle}>Junte-se à comunidade YBR</Text>

        {/* Tipo de usuário */}
        <Text style={styles.label}>Tipo de conta</Text>
        <View style={styles.tipoRow}>
          <TipoBtn value="locatario" label="🚗 Locatário" />
          <TipoBtn value="locador"   label="🔑 Locador" />
          <TipoBtn value="ambos"     label="🔄 Ambos" />
        </View>

        <Text style={styles.label}>Nome completo *</Text>
        <TextInput style={styles.input} placeholder="João da Silva" value={form.nome} onChangeText={v => update('nome', v)} />

        <Text style={styles.label}>E-mail *</Text>
        <TextInput style={styles.input} placeholder="joao@email.com" keyboardType="email-address" autoCapitalize="none" value={form.email} onChangeText={v => update('email', v)} />

        <Text style={styles.label}>Senha * (mín. 6 caracteres)</Text>
        <TextInput style={styles.input} placeholder="••••••••" secureTextEntry value={form.senha} onChangeText={v => update('senha', v)} />

        <Text style={styles.label}>Telefone</Text>
        <TextInput style={styles.input} placeholder="(49) 99999-0000" keyboardType="phone-pad" value={form.telefone} onChangeText={v => update('telefone', v)} />

        <Text style={styles.label}>CPF / CNPJ</Text>
        <TextInput style={styles.input} placeholder="000.000.000-00" keyboardType="numeric" value={form.documento} onChangeText={v => update('documento', v)} />

        {!!erro && <Text style={styles.erro}>{erro}</Text>}

        <TouchableOpacity
          style={[styles.btnPrimary, loading && { opacity: 0.7 }]}
          onPress={handleRegister}
          disabled={loading}
        >
          {loading
            ? <ActivityIndicator color="#1a1a1a" />
            : <Text style={styles.btnPrimaryText}>Criar Conta</Text>
          }
        </TouchableOpacity>

        <TouchableOpacity onPress={() => navigation.goBack()}>
          <Text style={styles.linkText}>Já tenho conta · <Text style={styles.linkBold}>Entrar</Text></Text>
        </TouchableOpacity>
      </ScrollView>
    </KeyboardAvoidingView>
  );
}

const styles = StyleSheet.create({
  container:    { flex: 1, backgroundColor: '#fff', paddingHorizontal: 24, paddingTop: 16 },
  title:        { fontSize: 28, fontWeight: '900', color: '#1a1a1a', marginBottom: 4 },
  subtitle:     { fontSize: 14, color: '#888', marginBottom: 24 },
  label:        { fontSize: 13, fontWeight: '600', color: '#555', marginBottom: 6, marginTop: 14 },
  input:        { backgroundColor: '#f5f5f5', borderRadius: 10, paddingHorizontal: 14, paddingVertical: 12, fontSize: 15, color: '#1a1a1a' },
  tipoRow:      { flexDirection: 'row', gap: 8, marginBottom: 4 },
  tipoBtn:      { flex: 1, paddingVertical: 10, borderRadius: 10, backgroundColor: '#f5f5f5', alignItems: 'center' },
  tipoBtnActive:{ backgroundColor: '#F5C518' },
  tipoBtnText:  { fontSize: 12, color: '#666', fontWeight: '600' },
  tipoBtnTextActive: { color: '#1a1a1a' },
  btnPrimary:   { backgroundColor: '#F5C518', borderRadius: 12, paddingVertical: 14, alignItems: 'center', marginTop: 28, marginBottom: 14 },
  btnPrimaryText: { fontSize: 16, fontWeight: 'bold', color: '#1a1a1a' },
  linkText:     { textAlign: 'center', color: '#666', fontSize: 14 },
  linkBold:     { fontWeight: 'bold', color: '#1a1a1a' },
  erro:         { backgroundColor: '#fdecea', color: '#c0392b', borderRadius: 8, padding: 10, marginTop: 12, fontSize: 14, textAlign: 'center' },
});
